export default __webpack_public_path__ + "static/BHM_TeenVogue_Banners_1500x565-89528be1aa5a407b896b7340a50cce41.jpg";